import React from 'react';
const Header = () => {
  return <header className="w-full" data-id="element-126">
      <div className="bg-[#8b5a00] py-2 px-4 flex justify-center" data-id="element-127">
        <h1 className="text-white text-2xl font-serif" data-id="element-128">THE ART JOURNAL</h1>
      </div>
      <div className="bg-[#f5f5f5] py-1 px-4 text-xs text-gray-600 flex justify-between" data-id="element-129">
        <span data-id="element-130">ADVERTORIAL</span>
        <span data-id="element-131">HEALTH & WELLNESS</span>
      </div>
    </header>;
};
export default Header;